import React from 'react';
import { cn } from '../utils/cn';

interface TypographyProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  className?: string;
}

export const H1: React.FC<TypographyProps> = ({ children, className, ...props }) => {
  return (
    <h1 className={cn('text-h1 font-bold font-display text-juridico', className)} {...props}>
      {children}
    </h1>
  );
};

export const H2: React.FC<TypographyProps> = ({ children, className, ...props }) => {
  return (
    <h2 className={cn('text-h2 font-semibold font-display text-juridico', className)} {...props}>
      {children}
    </h2>
  );
};

export const H3: React.FC<TypographyProps> = ({ children, className, ...props }) => {
  return (
    <h3 className={cn('text-h3 font-semibold text-juridico', className)} {...props}>
      {children}
    </h3>
  );
};

export const Body: React.FC<TypographyProps> = ({ children, className, ...props }) => {
  return (
    <p className={cn('text-body text-juridico', className)} {...props}>
      {children}
    </p>
  );
};

export const Small: React.FC<TypographyProps> = ({ children, className, ...props }) => {
  return (
    <span className={cn('text-small text-titan', className)} {...props}>
      {children}
    </span>
  );
};

export const Caption: React.FC<TypographyProps> = ({ children, className, ...props }) => {
  return (
    <span className={cn('text-xs text-titan', className)} {...props}>
      {children}
    </span>
  );
};

